import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { mobileAndTabletCSS } from '@measures/responsive'
import useIsImmersiveHeaderActive from '@hooks/useIsImmersiveHeaderActive'
import Blink from '@components/Blink'
import useTrackingUtils from '@components/Header/useTrackingUtils'

interface FirstLevelLinkProps {
  children: string
  href: string
}

const StyledFirstLevelLink = styled(Blink)<{
  isImmersiveHeaderActive: boolean
}>`
  ${({
    theme: {
      typography: {
        labels: {
          label2: { bundledCSS: label2LabelsCSS },
        },
      },
      colors: { textDefault, staticWhite },
    },
    isImmersiveHeaderActive,
  }) => css`
    ${label2LabelsCSS};
    color: ${textDefault};

    appearance: none;
    text-decoration: none;
    white-space: nowrap;

    ${isImmersiveHeaderActive &&
    css`
      ${mobileAndTabletCSS(css`
        color: ${staticWhite};
      `)}
    `}
  `}
`

const FirstLevelLink: FunctionComponent<FirstLevelLinkProps> = ({
  href,
  children,
}) => {
  const isImmersiveHeaderActive = useIsImmersiveHeaderActive()
  const { navbarClickTrackingFn } = useTrackingUtils({
    title: children,
    url: href,
  })
  return (
    <StyledFirstLevelLink
      href={href}
      ariaLabel={children}
      onClick={navbarClickTrackingFn}
      isImmersiveHeaderActive={isImmersiveHeaderActive}
    >
      {children}
    </StyledFirstLevelLink>
  )
}

export default FirstLevelLink
